import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from "./store"
import 'element-plus/dist/index.css'
import '@/assets/css/main.css'
import '@/assets/css/theme.less'

// import ECharts from 'vue-echarts' // 引入ECharts
import "echarts"; // 全局引入echarts

//引入elementUI-plus
import ElementPlus from 'element-plus'
//引入Element Plus中文语言包
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
//全局属性，方法，组件入口
import plugins from "./assets/js/plugins"
const app = createApp(App)
//配置Element Plus使用中文
app.use(ElementPlus, {
  locale:zhCn
})
app.use(router)
app.use(plugins)
// app.component('ECharts',ECharts)
app.use(store)
window.vm=app.mount('#app')
